import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NotificationAPIService } from 'src/app/extensions/services/api/notification-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { Filter, NOTIFICATION_FILTER_DATA } from '../../extensions/constants/notification-constants';

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: false,
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Output() closeNotificationsPopOver: EventEmitter<Event> = new EventEmitter<Event>();

  public unreadCount = 0;
  public filter = Filter.All;
  public notifications: app.models.NotificationModel[];
  public filteredNotifications: app.models.NotificationModel[];
  public subscriptions: Subscription[] = [];

  public constructor(
    private _globalService: GlobalService,
    private _notificationAPIService: NotificationAPIService,
    private _translate: TranslateService,
    private _router: Router
  ) {}

  public ngOnInit(): void {
    let obsNewNotificationSubscription = this._globalService.obsNewNotification.subscribe(newNotification => {
      if (newNotification) {
        this.loadData();
      }
    });
    this.subscriptions.push(obsNewNotificationSubscription);

    this.loadData();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  loadData() {
    this._notificationAPIService.getNotifications().subscribe(result => {
      this.notifications = result;
      this.unreadCount = 0;
      this.unreadCount = this.notifications.filter(x => !x.isRead).length;
      this._globalService.numberOfNotifications = this.unreadCount;

      this.notifications.forEach(x => {
        x.notificationBody = this._translate.instant('notification.body.' + x.notificationBody);
        var details = JSON.parse(x.notificationDetails);
        if (details != null) {
          Object.entries(details).forEach(detail => {
            x.notificationBody = x.notificationBody.replace(
              `{{${detail[0]}}}`,
              `<span class="data-hj-suppress">${detail[1]}</span>`
            );
          });
          if (details.hasOwnProperty('request_link')) {
            x.link = details['request_link'];
          }
        }
      });

      this.filteredNotifications = this.notifications;
    });
  }

  public filterHandler(filterName: string) {
    this.filter = Filter[filterName];

    let filterEntityTypes = NOTIFICATION_FILTER_DATA.find(x => x.filterName === this.filter);

    if (filterName != 'All') {
      this.filteredNotifications = this.notifications.filter(x =>
        filterEntityTypes.notificationEntityTypeCodes.includes(x.entityData.code)
      );
    } else {
      this.filteredNotifications = this.notifications;
    }
  }

  markHandler(notification: app.models.NotificationModel) {
    var notificationsIds = [notification.activityId];
    this._notificationAPIService.markNotificationsAsRead(notificationsIds).subscribe(response => {
      if (response.isSuccess) {
        notification.isRead = true;
        this.unreadCount--;
        this._globalService.numberOfNotifications = this.unreadCount;
        if (notification.isLink) {
          this.navigateToNotificationPage(notification);
        }
      }
    });
  }

  public displayReceivedDate(notificationDate: Date) {
    var hourDelta = this.calculateHourDelta(new Date(notificationDate), new Date());
    if (hourDelta < 1) {
      return '< 1h ago';
    }

    if (hourDelta < 24) {
      return `${hourDelta}h ago`;
    }

    return `${Math.floor(hourDelta / 24)} days ago`;
  }

  private calculateHourDelta(date1: Date, date2: Date) {
    return Math.floor(Math.abs((date1.getTime() - date2.getTime()) / 1000 / 60 / 60));
  }

  notificationClickHandler(notification: app.models.NotificationModel) {
    if (!notification.isRead) {
      this.markHandler(notification);
    } else if (notification.isLink) {
      this.navigateToNotificationPage(notification);
    }
  }

  navigateToNotificationPage(notification: app.models.NotificationModel) {
    this.closeNotificationsPopOver.emit();
    const [path, queryString] = notification.link.split('?');
    const queryParams: { [key: string]: string } = {};
    if (queryString) {
      queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        if (key) queryParams[key] = decodeURIComponent(value || '');
      });
    }
    this._router.navigate([path], { queryParams });
  }

  public closeNotificationsPopOverEvt(event: any) {
    event.preventDefault();
    this.closeNotificationsPopOver.emit();
  }
}
